import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
import { HS_ACADEMY_VIDEO_MARKETING_URL } from 'FileManagerCore/Constants';
import { getInAppVideoKey } from '../../selectors/ModalDisplay';
import usageTracker from '../../utils/usageTracker';
import { ACADEMY_VIDEO_IDS } from '../AcademyVideoLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyVideoModal = ({
  closeModal
}) => {
  const videoKey = useSelector(getInAppVideoKey);
  const videoTitle = videoKey.replaceAll('_', ' ').toLowerCase();
  useEffect(() => {
    usageTracker.track('fileManagerVideoInteraction', {
      action: 'open academy video',
      videoTitle
    });
  }, [videoTitle]);
  const handleClickCta = () => {
    usageTracker.track('fileManagerVideoInteraction', {
      action: 'click academy cta',
      videoTitle
    });
  };
  const handlePlay = () => {
    usageTracker.track('fileManagerVideoInteraction', {
      action: 'play academy video',
      videoTitle
    });
  };
  const handleFinished = () => {
    usageTracker.track('fileManagerVideoInteraction', {
      action: 'finished academy video',
      videoTitle
    });
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 800,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `FileManagerCore.academyVideos.${videoKey.toLowerCase()}.title`
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => closeModal()
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(HubSpotVideoPlayer, {
        videoId: ACADEMY_VIDEO_IDS[videoKey],
        onPlay: handlePlay,
        onFinish: handleFinished
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      className: "flex-row justify-center",
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        href: HS_ACADEMY_VIDEO_MARKETING_URL,
        external: true,
        onClick: handleClickCta,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerCore.academyVideos.cta"
        })
      })
    })]
  });
};
export default AcademyVideoModal;